import { useEffect, useState } from "react";

const FileInputField = ({
  name,
  multiple = false,
  maxImages = Infinity,
  register,
  setValue,
  watch,
  accept,
  label,
}) => {
  const [images, setImages] = useState([]);
  const watchedFiles = watch(name) || [];

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    const currentImages = watchedFiles;

    if (currentImages.length + files.length > maxImages) {
      alert(`You can only upload a maximum of ${maxImages} images.`);
      return;
    }

    const imageUrls = files.map((file) => URL.createObjectURL(file));
    setImages((prevImages) => [...prevImages, ...imageUrls]);
    setValue(name, [...currentImages, ...files]); // Set the files in the form state
  };

  const handleRemoveImage = (index) => {
    const updatedImages = images.filter((_, i) => i !== index);
    const updatedFiles = watch(name).filter((_, i) => i !== index);

    setImages(updatedImages);
    setValue(name, updatedFiles); // Update the form state
  };

  useEffect(() => {
    if (Array.isArray(watchedFiles) && watchedFiles.length > 0) {
      const imageUrls = watchedFiles.map((file) => URL.createObjectURL(file));
      setImages(imageUrls);
    } else {
      setImages([]); // Clear images if no files are present
    }
  }, [watchedFiles]);

  return (
    <div>
      {/* Custom label that acts as a button */}
      <label
        htmlFor={name}
        className="cursor-pointer text-text-1/90 bg-bkg2  p-2 text-center hover:text-text-1/60"
      >
        {label}
      </label>
      <span>
        {" "}
        Max of {maxImages} {name}
      </span>
      <input
        id={name}
        type="file"
        accept={accept}
        multiple={multiple}
        {...register(name)}
        onChange={handleImageChange}
        className="mb-4 invisible"
        disabled={images.length >= maxImages}
      />
      <div className="flex flex-wrap gap-4">
        {images.map((image, index) => (
          <div key={index} className="relative">
            <img
              src={image}
              alt={`upload-${index}`}
              className="w-32 h-32 object-cover rounded"
            />

            <button
              onClick={() => handleRemoveImage(index)}
              type="button"
              className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-5 h-5 text-center text-sm"
            >
              ✕
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FileInputField;
